import { FC, HTMLAttributes, useEffect, useState } from 'react';
import { useIntl } from 'react-intl';
import { useDispatch, useSelector } from 'react-redux';

import LocationSearchInput from './LocationSearchInput';

import { ReactComponent as IconSearch } from '../../../../../assets/images/search.svg';
import { CoordinateMode, RadiusType } from '../../../../../models/coordinate.model';
import { coordinateData, updateCoordinateData, getSmartPhrases } from '../../../../../store/location';
import { loadersByName } from '../../../../../store/ui';
import { getRadius } from '../../../../../utils';
import { Dropdown } from '../../input';

interface OwnProps {
    classNameInput: string;
}

type Props = OwnProps & HTMLAttributes<HTMLDivElement>;

const RADIUS_LIST = [1, 2, 3, 4, 5, 6, 8, 10, 15];

const Search: FC<Props> = ({ classNameInput, ...props }) => {
    const dispatch = useDispatch();
    const intl = useIntl();
    const coordinate = useSelector(coordinateData);
    const radiusState = coordinate && coordinate.radius ? Number(coordinate.radius) : 1000;
    const [radius, setRadius] = useState<number>(getRadius(radiusState, RadiusType.Kilometers) || 1);
    const INPUT_CONTAINER = `${classNameInput}__input-container`;
    const TEXT_CONTAINER = `${INPUT_CONTAINER}__text-container`;
    const locationLoading = useSelector(loadersByName('location'));

    useEffect(() => {
        setRadius((getRadius(radiusState, RadiusType.Kilometers) as number) || 1);
        dispatch(getSmartPhrases());
    }, [coordinate, radiusState, dispatch]);

    return (
        <div {...props}>
            <div className={INPUT_CONTAINER}>
                <div className={TEXT_CONTAINER}>
                    <IconSearch />
                    <LocationSearchInput classNameContainer={`${INPUT_CONTAINER}`} />
                </div>
                {Number(coordinate.mode) === CoordinateMode.City && (
                    <div>
                        {intl.formatMessage({
                            id: 'searchFilter.wholeCity',
                            defaultMessage: 'Ganze Stadt',
                        })}
                    </div>
                )}
                {Number(coordinate.mode) !== CoordinateMode.City && (
                    <div className={`${INPUT_CONTAINER}--radius`}>
                        <span>{intl.formatMessage({ id: 'searchFilter.radius', defaultMessage: 'Radius' })}</span>
                        <Dropdown
                            data={RADIUS_LIST}
                            dataKind={intl.formatMessage({ id: 'searchFilter.km', defaultMessage: 'km' })}
                            defaultSelected={radius}
                            disabled={locationLoading}
                            onSelect={v => {
                                setRadius(v as number);
                                dispatch(
                                    updateCoordinateData({
                                        mode: CoordinateMode.Radius,
                                        radius: getRadius(v as number, RadiusType.Meters),
                                    })
                                );
                            }}
                        />
                    </div>
                )}
            </div>
        </div>
    );
};

export default Search;
